<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('q58')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="combinedList.length === 0" :description="$t('withdraw.empty_data')" />
        
        <div v-else class="item_list" v-for="(v, key) in combinedList" :key="key">
          <div class="topInfo">
            <!-- 根据记录类型显示 -->
            <span v-if="v.record_type === 'recharge'" :style="{ color: getRecordColor(v) }">
              {{ getRechargeTitle(v) }}
            </span>
            <span v-else-if="v.record_type === 'bet'" style="color: #07c160">
              {{ $t('q66') }}
            </span>
            
            <!-- 金额显示 -->
            <span :style="{ color: getAmountColor(v) }" style="float: right">
              {{ formatAmount(v) }}
            </span>
          </div>
          
          <!-- 时间显示 -->
          <div class="time">
            <span v-if="v.record_type === 'recharge'">{{ $t('q63') }}：{{ v.create_time }}</span>
            <span v-else-if="v.record_type === 'bet'">{{ $t('q63') }}：{{ v.settle_time }}</span>
          </div>
          
          <!-- 充值记录的到账时间 -->
          <div v-if="v.record_type === 'recharge' && v.update_time && v.update_time !== '-'" class="time">
            <span>{{ $t('q64') }}：{{ v.update_time }}</span>
          </div>
          
          <!-- 投注记录的类型和期号 -->
          
          
          
          
          <!-- 投注记录的中奖金额 -->
          
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      rechargeList: [],   // 充值记录
      betList: [],        // 投注记录
      combinedList: []    // 合并后的列表
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    onRefresh() {
      this.loadAllRecords().then(() => {
        this.isLoading = false;
        this.$toast(this.$t("reservation.refresh"));
      }).catch(() => {
        this.isLoading = false;
      });
    },
    
    // 加载所有记录
    async loadAllRecords() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push({ path: '/Login' });
          return;
        }
        
        console.log('开始加载所有记录...');
        
        // 并行加载充值记录和投注记录
        await Promise.all([
          this.loadRechargeList(),
          this.loadBetRecords()
        ]);
        
        // 合并记录
        this.combineRecords();
        
      } catch (error) {
        console.error('加载失败:', error);
        this.$toast('网络异常，请稍后重试');
      }
    },
    
    // 加载充值记录
    async loadRechargeList() {
      try {
        const res = await this.$http({
          method: 'get',
          url: 'user_get_recharge_list'
        });
        
        console.log('充值记录响应:', res);
        
        if (res.code === 200) {
          this.processRechargeData(res);
        } else if (res.code === 401) {
          this.handleUnauthorized();
        } else {
          console.warn('获取充值记录失败:', res.msg);
        }
      } catch (error) {
        console.error('加载充值记录失败:', error);
      }
    },
    
    // 处理充值记录数据
    processRechargeData(res) {
      let records = [];
      
      // 优先使用 data2 字段
      if (res.data2 && Array.isArray(res.data2)) {
        records = res.data2;
        console.log('充值记录条数:', records.length);
      } else if (res.data && Array.isArray(res.data)) {
        records = res.data;
        console.log('充值记录条数:', records.length);
      }
      
      // 格式化充值记录
      this.rechargeList = records.map(item => {
        const amount = parseFloat(item.money || 0);
        const type = parseInt(item.type || 1);
        
        return {
          record_type: 'recharge',
          id: item.id,
          mid: item.mid,
          amount: amount,
          type: type,
          create_time: this.formatTime(item.create_time),
          update_time: this.formatTime(item.update_time),
          timestamp: parseInt(item.create_time || 0) * 1000 // 修正：直接计算时间戳
        };
      });
    },
    
    // 加载投注记录
    async loadBetRecords() {
      try {
        console.log('开始加载投注记录...');
        
        const res = await this.$http({
          method: 'get',
          url: 'game_get_bet_records',
          data: {
            status: 1, // 只获取已结算的记录
            limit: 50, // 获取50条
            page: 1
          }
        });
        
        console.log('投注记录响应:', res);
        
        if (res.code === 200) {
          this.processBetData(res);
        } else if (res.code === 401) {
          console.warn('投注记录接口认证失败:', res.msg);
          // 尝试不带参数的请求
          await this.tryGetBetRecordsWithoutParams();
        } else {
          console.warn('获取投注记录失败:', res.msg);
        }
      } catch (error) {
        console.error('加载投注记录失败:', error);
        this.betList = [];
      }
    },
    
    // 尝试不带参数获取投注记录
    async tryGetBetRecordsWithoutParams() {
      try {
        const res = await this.$http({
          method: 'get',
          url: 'game_get_bet_records'
        });
        
        if (res.code === 200) {
          this.processBetData(res);
        } else {
          console.warn('不带参数获取投注记录失败:', res.msg);
          this.betList = [];
        }
      } catch (error) {
        console.error('不带参数获取失败:', error);
        this.betList = [];
      }
    },
    
    // 处理投注记录数据
    processBetData(res) {
      let records = [];
      
      // 根据接口返回的数据结构提取记录
      if (res.data && Array.isArray(res.data)) {
        records = res.data;
      } else if (res.data2 && Array.isArray(res.data2)) {
        records = res.data2;
      } else if (res.records && Array.isArray(res.records)) {
        records = res.records;
      } else if (res.data && res.data.records && Array.isArray(res.data.records)) {
        records = res.data.records;
      }
      
      console.log('投注记录原始数据:', records);
      
      // 格式化投注记录
      this.betList = records.map(item => {
        const betAmount = parseFloat(item.bet_amount || item.money || 0);
        const profit = parseFloat(item.profit || 0);
        const displayTime = item.settle_time;
         
        // 排序时间戳：使用调整后的时间戳参与排序
        let sortTimestamp;
        
        if (item.adjusted_settle_timestamp) {
          // 后端已经提供了调整后的时间戳
          sortTimestamp = item.adjusted_settle_timestamp * 1000; // 转换为毫秒
        } else if (item.settle_timestamp) {
          // 后端没有提供调整后的时间戳，我们自己计算（原始时间戳减一小时）
          sortTimestamp = (item.settle_timestamp - 3600) * 1000; // 减一小时并转为毫秒
        } else {
          // 从显示时间转换
          sortTimestamp = this.getTimestampFromData(displayTime);
        }
        
        // 如果没有时间戳，使用投注时间（未结算的记录）
        if (!sortTimestamp && item.bet_timestamp) {
          sortTimestamp = item.bet_timestamp * 1000;
        }
        
        return {
          record_type: 'bet',
          id: item.id,
          bet_amount: betAmount,
          profit: profit,
          bet_type: item.type || item.bet_type,
          expect: item.expect,
          settle_time: displayTime, // 修正：去掉多余的s
          timestamp: sortTimestamp, // 使用调整后的时间戳排序
          _raw_settle_timestamp: item.settle_timestamp,
          _adjusted_settle_timestamp: item.adjusted_settle_timestamp,
          _raw_bet_timestamp: item.bet_timestamp
        };
      });
      
      console.log('格式化后的投注记录:', this.betList);
    },
    
    // 从时间数据获取时间戳
    getTimestampFromData(timeData) {
      if (!timeData) return 0;
      
      // 如果已经是时间戳
      if (typeof timeData === 'number') {
        // 判断是秒还是毫秒
        return timeData < 10000000000 ? timeData * 1000 : timeData;
      }
      
      // 如果是日期字符串
      if (typeof timeData === 'string') {
        const date = new Date(timeData);
        return date.getTime();
      }
      
      return 0;
    },
    
    // 合并记录
    combineRecords() {
      const allRecords = [...this.rechargeList, ...this.betList];
      
      console.log('排序前记录时间戳:');
      allRecords.forEach(record => {
        const date = new Date(record.timestamp);
        console.log(`${record.record_type} - ${record.id}:`, 
                    record.timestamp, 
                    date.toISOString(),
                    record.settle_time || record.create_time);
      });
      
      // 按时间戳降序排序（最新的在前）
      // 投注记录使用调整后的时间戳，充值记录使用原始时间戳
      this.combinedList = allRecords.sort((a, b) => {
        const timeA = a.timestamp || 0;
        const timeB = b.timestamp || 0;
        const result = timeB - timeA;
        
        // 调试排序
        if (Math.abs(result) < 1000 * 60 * 60 * 2) { // 2小时内的记录
          console.log(`排序比较: ${a.record_type}:${a.id}(${new Date(timeA).toISOString()}) vs ${b.record_type}:${b.id}(${new Date(timeB).toISOString()}) = ${result}`);
        }
        
        return result;
      });
      
      console.log('合并后的记录:', this.combinedList);
    },
    
    // 处理未授权
    handleUnauthorized() {
      this.$toast('登录已过期，请重新登录');
      localStorage.removeItem('token');
      this.$router.push({ path: '/Login' });
    },
    
    // 格式化时间
    formatTime(timeData) {
      if (!timeData || timeData === '-' || timeData === '0') return '-';
      
      let timeNum = this.getTimestampFromData(timeData);
      if (!timeNum) return timeData; // 如果无法获取时间戳，返回原始数据
      
      try {
        const date = new Date(timeNum);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');
        const second = date.getSeconds().toString().padStart(2, '0');
        
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      } catch (e) {
        console.error('时间格式化错误:', e);
        return timeData;
      }
    },
    
    // 获取记录颜色
    getRecordColor(item) {
      if (item.record_type === 'recharge') {
        const amount = parseFloat(item.amount || 0);
        return amount > 0 ? '#07c160' : '#ff4444';
      }
      return '#ff9900';
    },
    
    // 获取充值记录标题
    getRechargeTitle(item) {
      const amount = parseFloat(item.amount || 0);
      const type = parseInt(item.type || 1);
      
      if (amount > 0) {
        if (type === 1) return this.$t('q65'); // 充值
        if (type === 2) return this.$t('q66'); // 到账
        return this.$t('q65'); // 默认
      } else {
        return this.$t('q62'); // 提现
      }
    },
    
    // 获取金额颜色
    getAmountColor(item) {
      if (item.record_type === 'recharge') {
        const amount = parseFloat(item.amount || 0);
        return amount > 0 ? '#07c160' : '#07c160';
      } else if (item.record_type === 'bet') {
        // 投注金额显示为红色（支出）
        return '#07c160';
      }
      return '#f3c7a2';
    },
    
    // 格式化金额显示
    formatAmount(item) {
      if (item.record_type === 'recharge') {
        const amount = parseFloat(item.amount || 0);
        return amount > 0 ? `+${amount}` : `${amount}`;
      } else if (item.record_type === 'bet') {
        const betAmount = parseFloat(item.bet_amount || 0);
        return `+${betAmount}`;
      }
      return '';
    }
  },
  
  created() {
    const token = localStorage.getItem('token');
    console.log('页面创建，token:', token);
    
    if (!token) {
      this.$router.push({path: '/Login'});
    } else {
      this.loadAllRecords();
    }
  }
};
</script>
<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 15px 15px;
  margin: 20px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  line-height: 60px;
  color: #f3c7a2;
  border: 1px solid #766350;
}

.item_list .topInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.item_list .topInfo span{
  font-size: 32px;
  font-weight: 700;
}

.item_list .time span{
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
  opacity: 0.8;
  line-height: 40px;
}
</style>